<template>
  <div>
    <div class="loadingIndex">
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <div class="loadingtext">
        正在载入页面中....<br />若无法打开请刷新重试
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { setEncryptedData, setIv, setSessionKey } from "../../utils/auth";
export default {
  name: "overPage",
  data() {
    return {
      phone: "",
      clientId: "",
      key: ""
    };
  },
  mounted() {
    // alert(window.location);
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("hsx_") > 0) {
      this.requestBack(this.login);
    } else {
      if (this.$route.query.encryptedData) {
        setEncryptedData(this.$route.query.encryptedData);
      }
      if (this.$route.query.iv) {
        setIv(this.$route.query.iv);
      }
      if (this.$route.query.sessionKey) {
        setSessionKey(this.$route.query.sessionKey);
      }
      if (
        this.$route.query.encryptedData &&
        this.$route.query.iv &&
        this.$route.query.sessionKey
      ) {
        this.$router.replace({ path: "/login" });
      } else {
        this.$router.replace({ path: "/" });
      }
    }
  },
  methods: {
    ...mapActions(["login"]),
    requestBack(callback) {
      let that = this;
      window.WebViewJavascriptBridge.callHandler(
        "app_getUserInfo",
        {
          autoLogin: true
        },
        function(response) {
          let obj = JSON.parse(response);
          that.phone = obj.data.phone;
          that.userId = obj.data.userId;
          that.key = obj.data.key;
          callback({
            phone: that.phone,
            userId: that.userId,
            key: that.key,
            grant_type: "app_key",
            client: "web",
            IMEI: "IMEI",
            versionName: "v1.0"
          })
            .then(() => {
              that.$router.replace("/");
            })
            .catch(() => {
              that.$showError("授权失败");
            });
        }
      );
    }
  }
};
</script>

<style type="text/css">
.spinner {
  padding-top: 100px;
  margin: 0 auto 20px auto;
  width: 50px;
  height: 60px;
  text-align: center;
  font-size: 10px;
  overflow: hidden;
}

.spinner > div {
  background-color: #4287ef;
  height: 100%;
  width: 6px;
  display: inline-block;

  -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
  animation: stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}

@keyframes stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}

.loadingtext {
  text-align: center;
  font-size: 16px;
}

.loadingIndex {
  background: #fff;
  height: 100vh;
}
</style>
